import {
  TenantContextAction,
  UPDATE_TENANT_DATA,
  UPDATE_USERS_LIST,
  UsersMap,
} from "store/types/tenant-context.types";
import { Dispatch } from "redux";
import { findUsersByIds } from "api/user";
import { findTenantData } from "api/tenant-data";
import { TenantData } from "model/tenant-data.model";

/** ---- ACTIONS ---- */
export const updateUsersList = (
  userIds: Array<number>,
  userMap: UsersMap
) => async (dispatch: Dispatch<TenantContextAction>) => {
  try {
    const userIdsToAdd: Array<number> = [];
    userIds.forEach((userId: number) => {
      if (!userMap[userId]) {
        userIdsToAdd.push(userId);
      }
    });

    const userList = await findUsersByIds(userIdsToAdd);

    if (Object.keys(userList).length > 0) {
      dispatchUserList(userList)(dispatch);
    }
  } catch (e) {}
  return Promise.resolve();
};

export const loadTenantData = () => async (
  dispatch: Dispatch<TenantContextAction>
) => {
  try {
    const tenantData = await findTenantData();
    dispatchTenantData(tenantData)(dispatch);
  } catch (e) {}
  return Promise.resolve();
};

/** ---- DISPATCHERS ---- */
const dispatchTenantData = (tenantData: TenantData) => {
  return (dispatch: Dispatch<TenantContextAction>) => {
    dispatch({
      type: UPDATE_TENANT_DATA,
      payload: tenantData,
    });
  };
};

const dispatchUserList = (userMap: UsersMap) => {
  return (dispatch: Dispatch<TenantContextAction>) => {
    dispatch({
      type: UPDATE_USERS_LIST,
      payload: userMap,
    });
  };
};
